/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

import { createContext, useContext, useState } from 'react';

const Context = createContext({});

const DeliveredServicesContextProvider = ({ children }) => {

    const [paramsContext, setParamsContext] = useState(null)

    return (
        <Context.Provider value={{ paramsContext, setParamsContext }}>
            {children}
        </Context.Provider>
    );
};

const useDeliveredServicesContextProvider = () => {
    return useContext(Context);
};

export { DeliveredServicesContextProvider, useDeliveredServicesContextProvider};